import { Landmark } from 'lucide-react'
import { apiAssetUrl } from '@/lib/api/client'
import { cn } from '@/lib/utils'

/** Banka logosu; logo yoksa banka simgesi. */
export function BankLogo({ url, name, className }: { url?: string; name?: string; className?: string }) {
  if (!url) return <Landmark className={cn('text-muted-foreground size-4 shrink-0', className)} aria-hidden />
  return <img src={apiAssetUrl(url)} alt={name ? `${name} logosu` : ''} loading="lazy" className={cn('size-5 shrink-0 rounded object-contain', className)} />
}
